/**
 * tipStore — dica pós-busca (porta de `showTip` [application.js:4522]). A resposta do
 * /search pode trazer `tip` (+ opcional `suggestion`); o balão flutuante aparece por cima
 * de tudo e o usuário fecha no X. Desde o movimento de 23/10/2026 ele é o toast do guia e
 * também fecha sozinho quando a barra do tempo termina (4 s, parando com o mouse em cima;
 * TipToast.tsx).
 */
import { create } from 'zustand';

interface TipState {
  tip: string | null;
  suggestion?: string;
  showTip: (tip: string, suggestion?: string) => void;
  clearTip: () => void;
}

export const useTipStore = create<TipState>((set) => ({
  tip: null,
  suggestion: undefined,
  showTip: (tip, suggestion) => set({ tip, suggestion }),
  clearTip: () => set({ tip: null, suggestion: undefined }),
}));
